import { useMemo } from 'react';

const defArr = [2, 4, 8];

type PageType = any;
type PositionType = number;

export const useAddTopSalePost = (
  pagesArr: any[],
  topSaleItems: any[],
  positions = defArr
) => {
  return useMemo(() => {
    // Make object with top sale items by positions
    const topSaleItemsByPositions: { [key in PositionType]: PageType } = positions.reduce(
      (acc, position) => {
        if (!Array.isArray(topSaleItems)) return acc;

        const topSaleItem = topSaleItems.find(
          topSaleItem => topSaleItem.top_sale_position === position
        );

        return {
          ...acc,
          [position]: topSaleItem,
        };
      },
      {}
    );

    // Add topSaleItemsByPositions to pagesArr by positions
    return positions.reduce((acc, position) => {
      const topSaleItem = topSaleItemsByPositions[position];

      return !acc.includes(topSaleItem) && topSaleItem
        ? [...acc.slice(0, position - 1), topSaleItem, ...acc.slice(position - 1)]
        : acc;
    }, pagesArr || []);
  }, [pagesArr, topSaleItems, positions]);
};
